import { HelperText } from '~/components/helper-text'
import type { TIconProps } from '~/components/icon'
import { useInputCreditCardProps } from '../../hooks'

export const InputCreditCardHelperText = ({
  children,
  withIcon = false,
  iconName,
}: {
  children: React.ReactNode
  withIcon?: boolean
  iconName?: TIconProps['symbol']
}) => {
  const { hasError, disabled, readonly } = useInputCreditCardProps()

  return !hasError ? (
    <HelperText
      disabled={disabled}
      readonly={readonly}
      withIcon={withIcon}
      iconName={iconName}
      iconSize="tiny"
    >
      {children}
    </HelperText>
  ) : null
}
